import { inject, InjectionToken, Provider } from '@angular/core';
import { EmptyStateVisualSource } from './empty-state-visual-sources';

const EMPTY_STATE_DEFAULT_VISUAL_SRC_TOKEN = new InjectionToken<EmptyStateVisualSource>('__EMPTY_STATE_DEFAULT_VISUAL_SRC_TOKEN__');

export function provideDefaultEmptyStateVisualSource(source: EmptyStateVisualSource): Provider {
    return {
        provide: EMPTY_STATE_DEFAULT_VISUAL_SRC_TOKEN,
        useValue: source
    };
}

export function injectDefaultEmptyStateVisualSource(): EmptyStateVisualSource {
    return inject(EMPTY_STATE_DEFAULT_VISUAL_SRC_TOKEN, { optional: true }) ?? 'seemore-boxes-animation';
}
